import { defineStore, mapState, mapActions, Store, mapWritableState } from 'pinia';
import { bootstrap } from './pinia.bootstrap';
import { Nullable } from '@/models/Nullable';

const storeId = 'root';
const percistanceFileName = `${storeId}.store`;

type RootType = {
  cookieConsent: 'accepted' | 'declined' | null;
};

type StoreRootType = Store<'root', RootType>;

const useStore = defineStore(storeId, {
  state: () =>
    ({
      cookieConsent: null,
    } as RootType),
  actions: {
    resetConsent() {
      this.cookieConsent = null;
    },
  },
});

const actions = {
  ...mapActions(useStore, ['resetConsent']),
};

const computed = {
  writable: mapWritableState(useStore, ['cookieConsent']),
  readonly: mapState(useStore, ['cookieConsent']),
};

class RootPersistancy {
  public static storeId = storeId;

  public percist(
    type: 'load' | 'save',
    store: Nullable<StoreRootType>,
    state: Nullable<RootType>
  ): void {
    if (type === 'save') {
      this.save(state!);
    } else if (type === 'load') {
      this.load(store!);
    }
  }

  private load(store: StoreRootType): void {
    const { cookieConsent } = JSON.parse(localStorage.getItem(percistanceFileName) || '{}');
    store.$patch({
      cookieConsent: cookieConsent ?? null,
    });
  }

  private save(state: RootType): void {
    const { cookieConsent } = state;
    localStorage.setItem(
      percistanceFileName,
      JSON.stringify({
        cookieConsent,
      })
    );
  }
}

const rootPersistancy = new RootPersistancy();
bootstrap(RootPersistancy.storeId, (type: 'save' | 'load', store: unknown, state: unknown) => {
  rootPersistancy.percist(type, store as any, state as any);
});

export { useStore as useRootStore, actions as rootActions, computed as rootComputed };
